// Utility to generate a grouping hash for cart/order items
// Groups by variant id, normalized form_answers, and sales_price

export function getGroupItemHash({
  variantId,
  formAnswers,
  salesPrice,
}: {
  variantId: string | number
  formAnswers: any
  salesPrice: string | number
}): string {
  // Normalize form_answers for comparison (stringify, handle missing)
  const normalizeFormAnswers = (fa: any) => {
    try {
      if (typeof fa === "string") {
        let parsed = JSON.parse(fa)
        if (typeof parsed === "string") parsed = JSON.parse(parsed)
        return JSON.stringify(parsed)
      }
      return JSON.stringify(fa)
    } catch {
      return ""
    }
  }
  return `${variantId}::${normalizeFormAnswers(formAnswers)}::${salesPrice}`
}
